import Vue from 'vue';
import VCalendar from 'v-calendar';
import moment from 'vue-moment';
import VModal from 'vue-js-modal';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.use(moment);
Vue.use(VModal);
Vue.use(VCalendar);

Vue.config.productionTip = false;


/**
 * 画面遷移時に常にhookされる
 */
router.beforeEach((to, from, next) => {
  if (!store.getters.getIsBack) {
    // 戻る状態以外のとき($router.push()時)は、遷移前の画面パスを保存する
    store.commit('setPrevPath', { prevPath: from.path });
  }
  store.commit('setIsBack', false);
  // 遷移先のmetaがrootの場合は、pathを空の配列にする
  // 途中の画面でハンバーガーメニューから他のroot画面に遷移したとき、pathの履歴がおかしくなるのを防ぐ
  if (typeof to.meta.isRoot !== 'undefined' && to.meta.isRoot) {
    store.commit('resetPath');
  }
  next();
});

window.$vm = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
